import './App.css';
import ImageCarousel from './components/imageCarousel/ImageCarousel';
import HeadlineImage from './components/headline/HeadlineImage';
import SocialMediaIcons from './components/socials/SocialMediaIcons';

function App() {
  return (
    <div>
      <div style={{ position: "relative" }}>
        <HeadlineImage src="headlineImage.png" alt="Headline Image" />
      </div>
      <SocialMediaIcons />
      <ImageCarousel />
    </div>
  );
}

export default App;
